import React, { useEffect, useMemo } from 'react'

import { DatePicker, Select, Space } from 'antd'
import {
  $financeManagers,
  financeManagerMounted,
} from '../../../../billing/withdrawals/list/model'
import { useUnit } from 'effector-react'
import dayjs from 'dayjs'
import { DatePickerProps } from 'antd/es/date-picker'

export type FiltersValue = {
  userIds?: string[]
  datePeriod?: DatePickerProps['value']
}

type Props = {
  value: FiltersValue
  onChange: (payload: FiltersValue) => void
  hasFullAccess: boolean
  classname?: string
}

const disabledDate: DatePickerProps['disabledDate'] = (current) => {
  return current ? current > dayjs().endOf('day') : false
}

export const KPIFilters: React.FC<Props> = ({
  value,
  onChange,
  hasFullAccess,
  classname,
}) => {
  const financeManagers = useUnit($financeManagers)

  const financeManagersOptions = useMemo(
    () =>
      financeManagers.map((item) => ({
        label: item.username,
        value: item.id,
      })),
    [financeManagers],
  )

  useEffect(() => {
    if (hasFullAccess) {
      financeManagerMounted()
    }
  }, [hasFullAccess])

  return (
    <Space className={classname}>
      <DatePicker
        value={value.datePeriod}
        disabledDate={disabledDate}
        picker="month"
        onChange={(date) => onChange({ ...value, datePeriod: date })}
      />
      {hasFullAccess && (
        <Select
          allowClear
          placeholder="Select an user id"
          mode="multiple"
          options={financeManagersOptions}
          value={value.userIds}
          onChange={(ids) =>
            onChange({
              ...value,
              userIds: ids?.length ? ids : undefined,
            })
          }
          style={{ width: 400 }}
        />
      )}
    </Space>
  )
}
